import { Column, Editing, Item, RequiredRule, Toolbar } from 'devextreme-react/data-grid';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Button as RxButton } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import api from '../../../services/api-configuration';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import useFormatMessage from '../../../utils/useFormatMessage';

export const TaseronFirmalar = () => {
    const { t } = useFormatMessage();
    const [dataSources, setDataSources] = useState([]);
    const ref = useRef();
    const mountedRef = useRef(true);

    let skipValidationCheck = false;


    useEffect(() => {
        fetchData();
        return () => {
            mountedRef.current = false;
        };
    }, []);

    const fetchData = async () => {
        try {
            const response = await api.post("subcontractor/getAll");
            if (mountedRef.current) {
                setDataSources(response.data.data || []);
            }
        } catch (error) {
            toast.error("Hata oluştu");
            console.error("Error fetching contractors:", error);
        }
    };

    const addModel = async (data, e) => {
        data.create_user_id = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'))
        data.code = "1"
        if (data.transport_company === undefined) {
            data.transport_company = false
        }
        if (data.contract_owner === undefined) {
            data.contract_owner = false
        }

        try {
            const response = await api.post("subcontractor/create", data);
            if (response.status === 200) {
                // e.component.saveEditData();
                skipValidationCheck = true;
                toast.success(t("Ekleme başarılı"));
                fetchData();
            }
        } catch (error) {
            console.error("Error adding contractor:", error);
            let errorMessage = error.response?.data?.error || "";
            toast.error(errorMessage || "Hata oluştu");
        }
    };

    const updateModel = async (e, data) => {
        const employeeId = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));
        if (data.newData.transport_company === undefined && data.oldData.transport_company === undefined) {
            data.newData.transport_company = false
        }
        if (data.newData.contract_owner === undefined && data.oldData.contract_owner === undefined) {
            data.newData.contract_owner = false
        }
        const body = { ...data.oldData, ...data.newData, update_user_id: employeeId };
        try {
            const response = await api.post("subcontractor/update", body);
            if (response.status === 200) {
                // e.component.saveEditData();
                skipValidationCheck = true;
                toast.success(t("Güncelleme başarılı"));
                fetchData();

            }
        } catch (error) {
            console.error("Error updating contractor:", error);
            let errorMessage = error.response?.data?.error || "";
            toast.error(errorMessage || "Hata oluştu");
        }
    };

    const onRowValidating = (e) => {
        if (e.brokenRules.length === 0) {
            if (skipValidationCheck) {
                e.isValid = true;
                skipValidationCheck = false;
                return;
            }

            e.isValid = false;
            if (!e.oldData) {
                addModel(e.newData, e);
            } else {
                updateModel(e, e);
            }
        }
    };
    return (
        <>
            <Breadcrumb current={t("Taşeron Firma")} />
            <Card className="p-4">
                <DatagridCustom
                    dataSource={dataSources}
                    reff={ref}
                    onRowValidating={onRowValidating}
                    onInitNewRow={(e) => {
                        e.data.is_active = true;
                        e.component.__addingStart = true;
                    }}
                >
                    <Editing
                        mode="row"
                        popup={{
                            title: t("Yeni Taşeron Firma"),
                            showTitle: true,
                            width: 700,
                            height: "auto",
                        }}
                        allowUpdating
                        allowAdding
                        useIcons
                    />
                    <Column dataField="code" caption={t("Firma Kodu")} selectedFilterOperation='contains' alignment='center' allowEditing={false}>
                        {/* <RequiredRule /> */}
                    </Column>
                    <Column dataField="name" caption={t("Firma Adı")} selectedFilterOperation='contains' alignment='center'>
                        <RequiredRule />

                    </Column>

                    <Column dataField="is_active" caption={t("Aktif")} dataType="boolean" selectedFilterOperation='contains' alignment='center'>
                        <RequiredRule />
                    </Column>

                    <Column dataField="transport_company" caption={t("Taşıyıcı Firma")} dataType="boolean" selectedFilterOperation='contains' alignment='center'>

                    </Column>

                    <Column dataField="contract_owner" caption={t("Kontrat Sahibi")} dataType="boolean" selectedFilterOperation='contains' alignment='center'>

                    </Column>

                    <Toolbar>
                        <Item name="addRowButton" />
                        <Item location="after">
                            <RxButton
                                color="light"
                                outline
                                onClick={fetchData}
                                style={{
                                    paddingInline: "10px",
                                    border: "1px solid #ddd"
                                }}
                            >
                                <i className="fa fa-refresh"></i>
                            </RxButton>
                            &nbsp;
                            <RxButton
                                className='btn btn-success'
                                style={{
                                    color: "white",
                                    paddingInline: "10px",
                                }}
                                onClick={(e) => ButtonOnExporting(e, ref, "Taşeron Firma",)}>
                                <i className="fa fa-file-excel-o"></i>

                            </RxButton>
                        </Item>
                    </Toolbar>
                </DatagridCustom>
            </Card>
        </>
    );
};